// Gradient Line Chart
import {
    Doughnut
} from 'vue-chartjs'
import {
    ChartConfig
} from "Constants/chart-config"
import {
    hexToRgbA
} from 'Helpers/helpers'

export default {
    extends: Doughnut,
    data() {
        return {
            gradient: null,
            gradient2: null
        }
    },
    props: {
        values: {
            type: Array,
            required: true
        },
        isMoneyValue: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        values: function (val) {
            if (val !== 0) {
               this.render()
            }
        }
    },
    methods: {
        render() {
            const self = this
            if (this.values.length > 0) {
                this.renderChart({
                    labels: this.values[0].map(item => item.label),
                    datasets: [{
                        labels: this.values[0].map(item => item.label),
                        borderColor: '#ffffff',
                        pointBorderColor: this.gradient,
                        pointBackgroundColor: this.gradient,
                        pointHoverBackgroundColor: this.gradient,
                        pointHoverBorderColor: this.gradient,
                        pointBorderWidth: 10,
                        pointHoverRadius: 10,
                        pointHoverBorderWidth: 1,
                        pointRadius: 3,
                        fill: true,
                        // backgroundColor: this.values.map(item => item.color), // this.gradient2,
                        borderWidth: 1,
                        data: this.values[0].map(item => item.value)// [100, 120, 150, 170, 180, 170, 160, 190]
                    },
                    {
                        labels: this.values[1].map(item => item.label),
                        backgroundColor: this.values[1].map(item => item.color),
                        borderColor: '#ffffff',
                        pointBorderColor: this.gradient,
                        pointBackgroundColor: this.gradient,
                        pointHoverBackgroundColor: this.gradient,
                        pointHoverBorderColor: this.gradient,
                        pointBorderWidth: 10,
                        pointHoverRadius: 10,
                        pointHoverBorderWidth: 1,
                        pointRadius: 3,
                        fill: true,
                        // backgroundColor: this.values.map(item => item.color), // this.gradient2,
                        borderWidth: 1,
                        data: this.values[1].map(item => item.value)// [100, 120, 150, 170, 180, 170, 160, 190]
                    }]
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'bottom',
                        onClick: (e) => e.stopPropagation()
                    },
          
                    tooltips: {
                        callbacks: {
                          label: function(tooltipItem, data) {
                            const formatter = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                            })
                            
                            const dataValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                            const label = data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index]
                            return `${label}: ${self.isMoneyValue ? formatter.format(dataValue) : dataValue}`

                            // var dataset = data.datasets[tooltipItem.datasetIndex];
                            // var index = tooltipItem.index;
                            // return dataset.labels[index] + ': ' + dataset.data[index];
                          }
                        }
                    }
                })
            }
  
        }
    },
    mounted() {
        this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(500, 0, 100, 0)
        this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(500, 0, 100, 0)

        this.gradient.addColorStop(0, ChartConfig.color.danger)
        this.gradient.addColorStop(1, ChartConfig.color.warning)

        this.gradient2.addColorStop(0, hexToRgbA(ChartConfig.color.danger, 0.6))
        this.gradient2.addColorStop(1, hexToRgbA(ChartConfig.color.warning, 0.6))
        this.render()
    }
}